"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowSelector = void 0;
const React = __importStar(require("react"));
const property_1 = require("@genesys/property");
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const Elements = __importStar(require("@genesys/client-core/lib/genesys-properties-selector-renderers/elements"));
const GenesysPropertiesSelectorHelpers = __importStar(require("@genesys/client-core/lib/genesys-properties-selector-helpers"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const RowSelector = (props) => {
    const originalProperties = props.properties.reduce((soFar, current) => {
        soFar[current.name] = current;
        return soFar;
    }, {});
    const propertiesWithoutVisibillityFilter = props.properties.map(property => (Object.assign(Object.assign({}, property), { visibility_filter: property_1.PropertyFilter.Empty })));
    return (React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.selectedProperties, productProperties: propertiesWithoutVisibillityFilter, screenAmountProfileFieldGroup: props.screenAmountProfileFieldGroup, onChange: pvs => props.onChange(pvs, props.rowIndex), uniqueId: props.screenAmountProfileFieldGroup + props.rowIndex, readOnlyProperties: props.readOnlyProperties, layoutRenderer: layoutProps => (React.createElement(Contexts.propertiesSelectorContext.Consumer, null, ({ layoutRendererExtraProps }) => {
            const selectorInfoMap = GenesysPropertiesSelectorHelpers.createSelectorInfoMap(layoutProps.selectors);
            return layoutRendererExtraProps.sections
                .map(section => section.groups)
                .reduce((soFar, current) => [...soFar, ...current], [])
                .map(group => group.properties)
                .reduce((soFar, current) => [...soFar, ...current], [])
                .map(property => {
                const selectorInfo = selectorInfoMap[property.propertyName];
                const originalProperty = originalProperties[property.propertyName];
                return (React.createElement("td", { key: selectorInfo.propertyName }, property_1.PropertyFilter.isValid(props.selectedProperties, originalProperty.visibility_filter) ? (React.createElement(React.Fragment, null,
                    React.createElement(Elements.DefaultPropertySelector, Object.assign({}, selectorInfo.selectorComponentProps)))) : undefined));
            });
        })) }));
};
exports.RowSelector = RowSelector;
//# sourceMappingURL=row-selector.js.map